<template>
  <LogoutPage />
</template>

<script>
  import LogoutPage from '../components/LogoutPage'

  export default {
    components: {
      LogoutPage
    }
  }
</script>
